import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';
import addSimpleOpacityAnimation from '../lib/add-simple-opacity-animation';

gsap.registerPlugin(ScrollTrigger);

const moduleSelector = '.decor-icons';
const moduleCallBack = (moduleElement, query, queryAll) => {
    const parentSectionElement = moduleElement.parentElement.closest('section');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: parentSectionElement,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(moduleElement, timeline);
    addSimpleOpacityAnimation(timeline, moduleElement, 0.3, 0.3, 0.1);
    const holder = queryAll('.decor-icons-item');
    holder.forEach((wrap) => {
        const icon = wrap.querySelector('.icon');
        let counter;
        // eslint-disable-next-line no-plusplus
        for (counter = 1; counter <= 9; ++counter) {
            const clonedIcon = icon.cloneNode(true);
            clonedIcon.classList.remove('icon-front');
            clonedIcon.classList.add('icon-back');
            clonedIcon.classList.add(`icon-${counter}`);
            wrap.append(clonedIcon);
        }
    });
};

export { moduleSelector, moduleCallBack };
